<ngx-captcha [config]="captchaConfig"></ngx-captcha>
    